module.exports = __webpack_public_path__ + "static/active-barre-20221-9ee925efaf5f1e65092acb236d9b94f5.jpg";